export default "__VITE_ASSET__gpeJ_MUD__"